module.exports = __webpack_public_path__ + "img/sofa-icon.26bccaed.svg";